// import React, { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation, useParams } from 'react-router-dom';
// import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
// import TopHeaderSection from '../../components/common/TopHeaderSection';
// import * as AstrologyApiActions from '../../redux/actions/astrologyApiAction';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

// const HoroscopeDetails = () => {
//   const { zodiacSign } = useParams();
//   const location = useLocation();
//   const zodiacImage = location?.state?.zodiacImage;
//   const dispatch = useDispatch();
//   const { isLoading } = useSelector(state => state?.commonReducer);
//   const { horoscopeData } = useSelector(state => state?.astrologyApiReducer);

//   const [activeTab, setActiveTab] = useState('daily');

//   useEffect(() => {
//     dispatch(AstrologyApiActions.getHoroscope({ zodiacSign }));
//   }, []);

//   const renderTabs = ['daily', 'weekly', 'monthly', 'yearly'];

//   const chartData = horoscopeData?.tags?.[activeTab]
//     ? Object.entries(horoscopeData.tags[activeTab]).map(([key, value]) => ({
//         name: key,
//         value
//       }))
//     : [];

//   return (
//     <>
//       <TopHeaderSection title={zodiacSign} />

//       <section className='px-[100px] max-lg:px-[20px] py-[50px]'>
//         <article>
//           <div className="relative flex justify-center mb-[50px]">
//             <hr className="w-full" />
//             <div>
//               <img  loading="lazy"  
//                 src={zodiacImage}
//                 alt="logo img"
//                 className="absolute h-10 -translate-y-1/2 bg-white px-4"
//                 style={{
//                   top: '50%',
//                   left: '50%',
//                   transform: 'translate(-50%, -50%)',
//                   zIndex: 1
//                 }}
//               />
//             </div>
//           </div>

//           {/* Tabs */}
//           <div className="flex gap-4 justify-center mb-8">
//             {renderTabs.map(tab => (
//               <button
//                 key={tab}
//                 onClick={() => setActiveTab(tab)}
//                 className={`px-4 py-2 rounded-full border ${
//                   activeTab === tab ? 'bg-black text-white' : 'bg-gray-200'
//                 } capitalize`}
//               >
//                 {tab}
//               </button>
//             ))}
//           </div>

//           {isLoading ? (
//             <main className='flex flex-col gap-7'>
//               {Array(5).fill('').map((_, index) => (
//                 <div className='flex flex-col gap-2' key={index}>
//                   <SkeletonTheme color="#e0e0e0" highlightColor="#f5f5f5">
//                     <div className='h-5'><Skeleton height={'100%'} /></div>
//                     <div className='h-5'><Skeleton height={'100%'} /></div>
//                     <div className='h-5'><Skeleton height={'100%'} /></div>
//                   </SkeletonTheme>
//                 </div>
//               ))}
//             </main>
//           ) : (
//             <main className='flex flex-col gap-10 text-[15.5px] text-gray-800 text-justify'>
//               {/* Render Horoscope HTML */}
//               <div dangerouslySetInnerHTML={{ __html: horoscopeData?.[activeTab] }} />

//               {/* Render Tags Bar Chart */}
//               {chartData.length > 0 && (
//                 <div className='w-full h-[300px]'>
//                   <ResponsiveContainer width="100%" height="100%">
//                     <BarChart data={chartData}>
//                       <XAxis dataKey="name" />
//                       <YAxis domain={[0, 100]} />
//                       <Tooltip />
//                       <Bar dataKey="value" fill="#4B5563" radius={[4, 4, 0, 0]} />
//                     </BarChart>
//                   </ResponsiveContainer>
//                 </div>
//               )}
//             </main>
//           )}
//         </article>
//       </section>
//     </>
//   );
// };

// export default HoroscopeDetails;





import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import TopHeaderSection from '../../components/common/TopHeaderSection';
import * as AstrologyApiActions from '../../redux/actions/astrologyApiAction';
import TabNav from './TabNav';
import TagsBarChart from './TagsBarChart';
import { motion, AnimatePresence } from 'framer-motion';

const HoroscopeDetails = () => {
  const { zodiacSign } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  console.log("Location State", location?.state);
  const zodiacImage = location?.state?.zodiacImage;
  const { isLoading } = useSelector(state => state?.commonReducer);
  const { horoscopeData } = useSelector(state => state?.astrologyApiReducer);
  const [searchParams, setSearchParams] = useSearchParams();

  const renderTabs = ['daily', 'weekly', 'monthly', 'yearly'];
  const defaultTab = searchParams.get('tab') || 'daily';
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    dispatch(AstrologyApiActions.getHoroscope({ sign: zodiacSign }));
  }, [dispatch, zodiacSign]);

  useEffect(() => {
    setSearchParams({ tab: activeTab });
  }, [activeTab]);

  const chartData = horoscopeData?.tags?.[activeTab]
    ? Object.entries(horoscopeData.tags[activeTab]).map(([key, value]) => ({
      name: key,
      value,
    }))
    : [];

  return (
    <>
      <TopHeaderSection title={zodiacSign} />

      <section className='px-[100px] max-lg:px-[20px] py-[50px]'>
        <article>
          {/* Divider with Zodiac Image */}
          {/* <div className="relative flex justify-center mb-[50px]">
            <hr className="w-full border-gray-300" />
            <div>
              <img  loading="lazy"  
                src={zodiacImage}
                alt="logo img"
                className="absolute h-10 -translate-y-1/2 bg-white px-4"
                style={{
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 1
                }}
              />
            </div>
          </div> */}

          {/* Tab Nav */}
          <TabNav
            tabs={renderTabs}
            activeTab={activeTab}
            onTabChange={setActiveTab}
          />

          {/* Content */}
          {isLoading ? (
            <main className='flex flex-col gap-7'>
              {Array(5).fill('').map((_, index) => (
                <div className='flex flex-col gap-2' key={index}>
                  <SkeletonTheme color="#e0e0e0" highlightColor="#f5f5f5">
                    <div className='h-5'><Skeleton height={'100%'} /></div>
                    <div className='h-5'><Skeleton height={'100%'} /></div>
                    <div className='h-5'><Skeleton height={'100%'} /></div>
                  </SkeletonTheme>
                </div>
              ))}
            </main>
          ) : (
            <AnimatePresence mode="wait">
              <motion.main
                key={activeTab}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className='flex flex-col gap-10 text-[15.5px] text-gray-800 text-justify'
              >
                {/* Horoscope HTML */}
                <div
                  className="prose max-w-none"
                  dangerouslySetInnerHTML={{ __html: horoscopeData?.[activeTab] }}
                />

                {/* Bar Chart */}
                <TagsBarChart data={chartData} />
              </motion.main>
            </AnimatePresence>
          )}
        </article>
      </section>
    </>
  );
};

export default HoroscopeDetails;
